<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import utils from '@/services/utils';

export default {
  name: 'app',
  mounted() {
    this.disableCopy();
  },
  methods: {
    disableCopy() {
      /* eslint-disable */
      const el = window.document.body;

      el.oncontextmenu = ((e) => {
        e.preventDefault();
      });

      el.onselectstart = ((e) => {
        e.preventDefault();
      });

      el.oncopy = ((e) => {
        e.preventDefault();
      });

      el.onkeydown = ((e) => {          
        const obj = e.target || e.srcElement; // 获取事件源
        const t = obj.type || obj.getAttribute('type');

        // 当敲Backspace键时，事件源类型非密码或单行、多行文本，则退格键失效
        const flag1 = e.keyCode == 8 && t !== "password" && t !== "text" && t !== "textarea" & t !== 'tel';
        if (flag1) return false;
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

html {
  height: 100%;
  font-size: $font-size;
  /*font-family: Microsoft Yahei, 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  color: $font-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-y: scroll;
}

body {
  height: 100%;
  // min-width: $content-width;
  background-color: $bg-color;
}

#app {
  height: 100%;
}
</style>
